import { CxEvent } from '@spartacus/core';

export class Ga4GgCartDiscountEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
}
